module.exports = __webpack_public_path__ + "img/1.40ec86c9.jpg";